/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import {AddToCartButton} from "../bootstrap/Button";

export const FrequentlyBoughtTogetherCartCell = ({isLoading, openModal, translate, color}) => {
    return <div className={"p-bundle-row__cell p-bundle-row__cell--selector"}>
        <div className={"addToCartButton"}>
            <AddToCartButton small className={"btn-block p-margin-bottom-sm"} loading={isLoading}
                             disabled={isLoading} block response onClick={openModal}
                             translate={translate} color={color}/>
        </div>
        <p className={"p-margin-top-sm"}>{translate("Select quantity in next step")}</p>
    </div>
};
